import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { AsyncViewsNav } from '@jira/navigation-apps__horizontal-nav-jsm-views/src/index.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import {
	getRapidBoardDataResource,
	getRapidboardResources,
} from '@jira/router-resources__classic-projects/src/getRapidboardResources.tsx';
import { getBoardDetailsResource } from '@jira/router-resources__classic-projects/src/getBoardDetailsResource.tsx';
import { getEditModelResource } from '@jira/router-resources__classic-projects/src/getEditModelResource.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { uifBoardResource } from '@jira/router-resources__uif-board/src/uifBoardResource.tsx';
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { jsmBoardRoute } from '@jira/router-routes__servicedesk-board-routes/src/jsmBoardRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { ClassicBoardSkeleton } from '@jira/platform__skeletons/src/ui/classic-board/ClassicBoardSkeleton.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { LazyServicedeskBoard, ServicedeskBoard, LazyBoardSettings } from './ui/view.tsx';

export const jsmBoardRouteEntry: Route = createEntry(jsmBoardRoute, () => ({
	group: 'servicedesk',
	// eslint-disable-next-line no-restricted-syntax
	component: ServicedeskBoard,
	layout: serviceProjectLayout,
	skeleton: ClassicBoardSkeleton,
	forPaint: [LazyAtlassianNavigation, LazyServicedeskBoard, LazyBoardSettings],
	perfMetricKey: 'servicedesk-boards-load',

	navigation: {
		menuId: MenuIdProjects,
		horizontal: AsyncViewsNav,
	},

	resources: [
		...getServiceDeskNavigationResources(),
		...getServicedeskPageContextResources(),
		getConsolidationStateResource(),
		...getRapidboardResources(),
		getRapidBoardDataResource(),
		resourceWithCondition(() => !__SERVER__, uifBoardResource),
		getEditModelResource(),
		getBoardDetailsResource(),
		projectContextResource,
	],

	supportsPreviewPanel: true,

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
